import React from 'react'
import Link from 'next/link';
import Image from 'next/image';

const Breadcumbs = ({ title, items }) => {
  return (
    <div className="Css-bg-bradcumb-comm">
      <Image
        src="/images/aarogyamhdna_breadcrumbs.webp"
        alt="Breadcrumb Background"
        fill
        style={{ objectFit: 'cover', zIndex: -1 }}
        fetchPriority="high"
        priority
      />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcumb-content">
              {title === "Blog Details" ? (
                <p className="breadcumb-title">{title}</p>
              ) : (
                <h1 className="breadcumb-title">{title}</h1>
              )}

              {/* <h1 className="breadcumb-title">{title}</h1> */}
              <ul className="breadcumb-menu">
                {items.map((item, index) => (
                  <li key={index}>
                    {item.href ? (
                      <Link href={item.href}>{item.label}</Link>
                    ) : (
                      item.label
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Breadcumbs
